(function () {
  if (window.YanaaDeps && typeof window.YanaaDeps.load === 'function') return;

  var scriptCache = Object.create(null);
  var styleCache = Object.create(null);
  var groupCache = Object.create(null);

  function ensureStyle(id, href) {
    if (!id || !href) return Promise.resolve();
    if (styleCache[id]) return Promise.resolve();

    var existing = document.getElementById(id);
    if (existing) {
      styleCache[id] = true;
      return Promise.resolve();
    }

    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
    styleCache[id] = true;
    return Promise.resolve();
  }

  function ensureScript(src) {
    if (!src) return Promise.resolve();
    if (scriptCache[src]) return scriptCache[src];

    scriptCache[src] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener(
          'load',
          function () {
            existing.dataset.loaded = 'true';
            resolve();
          },
          { once: true }
        );
        existing.addEventListener(
          'error',
          function () {
            reject(new Error('Failed to load script: ' + src));
          },
          { once: true }
        );
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.addEventListener(
        'load',
        function () {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener(
        'error',
        function () {
          reject(new Error('Failed to load script: ' + src));
        },
        { once: true }
      );
      document.head.appendChild(script);
    });

    return scriptCache[src];
  }

  function load(config) {
    var key = config && config.key ? config.key : 'default';
    if (groupCache[key]) return groupCache[key];

    var styles = (config && config.styles) || [];
    var scripts = (config && config.scripts) || [];

    groupCache[key] = Promise.all(styles.map(function (style) {
      return ensureStyle(style.id, style.href);
    })).then(function () {
      return scripts.reduce(function (chain, src) {
        return chain.then(function () {
          return ensureScript(src);
        });
      }, Promise.resolve());
    });

    return groupCache[key];
  }

  window.YanaaDeps = {
    load: load
  };

  document.dispatchEvent(new CustomEvent('yanaa:deps-loader-ready'));
})();
